import { useApiAWS } from '@/composables/useApi'

const apiAws = useApiAWS()

export function GetFrameVideoUrl() {
  this.execute = function (data) {
    return new Promise(async (resolve, reject) => {
      try {
        await apiAws.post('/frame-video', data)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}

export function GetFrameCardVideoUrl(){
  this.execute = function (data) {
    return new Promise(async (resolve, reject) => {
      try {
        await apiAws.post('/frame-card-video', data)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
